import { NgClass } from "@angular/common";
import {
  Component,
  inject,
  input,
  signal,
  computed,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { IconComponent } from "@claas/claas-ui-components";
import { TranslatePipe } from "@ngx-translate/core";
import { map } from "rxjs";
import { pathRouteParametersHelper$ } from "../../helpers/path-params.helper";

@Component({
  selector: "claas-breadcrumb",
  imports: [
    IconComponent,
    TranslatePipe,
    RouterLink,
    RouterLinkActive,
    NgClass,
  ],
  templateUrl: "./breadcrumb.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./breadcrumb.scss",
})
export class ProductDetailBreadcrumb {
  private router = inject(Router);
  productSeriesName = input();
  productName = input<string | null | undefined>("");

  routerPathParams = signal<string[]>(this.router.url.split("/"));
  countryID = toSignal(
    pathRouteParametersHelper$().pipe(
      map((params) =>
        params["country"]?.toLowerCase()
          ? encodeURIComponent(params["country"]?.toLowerCase() as string)
          : "",
      ),
    ),
    {
      initialValue: "",
    },
  );

  contacts = computed(
    () =>
      this.routerPathParams()[this.routerPathParams().length - 1] ===
      "contacts",
  );

  languageID = toSignal(
    pathRouteParametersHelper$().pipe(
      map((params) =>
        params["language"]?.toLowerCase()
          ? encodeURIComponent(params["language"]?.toLowerCase() as string)
          : "",
      ),
    ),
    {
      initialValue: "",
    },
  );

  year = toSignal(
    pathRouteParametersHelper$().pipe(
      map((params) =>
        params["year"]?.toLowerCase()
          ? encodeURIComponent(params["year"]?.toLowerCase() as string)
          : "",
      ),
    ),
    {
      initialValue: "",
    },
  );

  productSeriesID = toSignal(
    pathRouteParametersHelper$().pipe(
      map((params) =>
        params["id"] ? encodeURIComponent(params["id"] as string) : "",
      ),
    ),
    {
      initialValue: "",
    },
  );

  productID = toSignal(
    pathRouteParametersHelper$().pipe(
      map((params) =>
        params["productId"]
          ? encodeURIComponent(params["productId"] as string)
          : "",
      ),
    ),
    {
      initialValue: "",
    },
  );

  argumentID = toSignal(
    pathRouteParametersHelper$().pipe(
      map((params) =>
        params["argumentId"]
          ? encodeURIComponent(params["argumentId"] as string)
          : "",
      ),
    ),
    {
      initialValue: "",
    },
  );

  competitorID = toSignal(
    pathRouteParametersHelper$().pipe(
      map((params) =>
        params["competitorId"]
          ? encodeURIComponent(params["competitorId"] as string)
          : "",
      ),
    ),
    {
      initialValue: "",
    },
  );
}
